module.exports = __webpack_public_path__ + "static/Awasul_groups-3cfcd5e9735db518ec7786b4ba474ae3.png";